export default {
  title: "Mage",
  content: [
    "Amplify magic now slightly increases spell damage done. Only one can be active at a time per mage.",
    "Dampen Magic now slightly reduces spell damage taken. Only one can be active at a time per mage.",
  ],
};
